<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">
                     
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li >
                                  <router-link :title="' الاحداث'" :to="{name: 'parent-events'}">  الاحداث</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'الحدث: ' + event.name" :to="{name: 'parent-events', params: {id: event.id}}">  الحدث: {{event.name}}</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div class="row"> 
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                            <i class="flaticon-computer-4"></i> 
                                       الحدث: {{ event.name }}

                                        </h4>
                                    </div>          
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                              
                                <div class="table-responsive">
                               
                                    <table class="table table-bordered mb-4 mb-4">
                                      
                                        <tbody>
                                          <tr>
                                            <th>تاريخ الحدث</th>
                                            <td>{{event.event_date}}</td>
                                          </tr>
                                          <tr>
                                            <th>الحلقة</th>
                                            <td>{{event.lesson ? event.lesson.name : '---'}}</td>
                                          </tr>
                                        </tbody>
                                        
                                    </table>

                                     <ul class="nav nav-tabs" id="myTab" role="tablist" v-if="event.my_students">
                                      <li class="nav-item" v-for="(child, k) in event.my_students" :key="k">
                                        <a :class="k == 0 ? 'nav-link active' : 'nav-link'" :id="'child-' + child.id + '-tab'" data-toggle="tab" :href="'#c-child-' + child.id + '-tab'" role="tab" :aria-controls="'c-child-' + child.id + '-tab'" aria-selected="true"><i class="fa-regular fa-user text-primary"></i> {{child.name}}</a>
                                      </li>
                                    </ul>
                                      <div class="tab-content" id="myTabContent">
                                        <div v-for="(child, k) in event.my_students" :key="k" :class="k == 0 ? 'tab-pane fade show active' : 'tab-pane fade'" :id="'c-child-' + child.id + '-tab'" role="tabpanel" :aria-labelledby="'child-' + child.id + '-tab'">
                                          <img :src="child.pivot.img_path" :alt="event.name + ' ' + child.name">

                                        </div>
                                    
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                         
                    </div>
                   
                </div>
             

            </div>


</template>
<script>
import router from '@/router'

export default {
  data() {
    return {
      event: {},
      isRequested: false,
    };
  },
  created() {
    this.findOne();
  },
  methods: {
    findOne() {
      this.$baseApi.get('/parent-events/' + this.$route.params.id).then((response) => {
        if (response.data.code === 200 && response.data.data != null) {
          this.event = response.data.data.event;
          this.event.id = this.$route.params.id;
        } else if (response.data.code === 404) {
          router.push('/parent-events');
        } else {
          alert(response.data.error);
          router.push('/parent-events');
        }
      });
    },
  },
  computed: {
   
  }
}

</script>
<style>
</style>
